import { Cancel, ChangeCircle, CheckCircle } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

type AbsenceStatusDecisionActionsProps = {
  absenceId: string;
  onApprove: (absenceId: string) => void;
  onReject: (absenceId: string) => void;
  onRequestChange: (absenceId: string) => void;
};

export const AbsenceStatusDecisionActions = (
  props: AbsenceStatusDecisionActionsProps,
) => {
  const { absenceId, onApprove, onRequestChange, onReject } = props;

  const { t } = useTranslation();

  return (
    <Box>
      <Button
        size={'small'}
        onClick={() => onApprove(absenceId)}
        startIcon={<CheckCircle fontSize="small" color={'success'} />}
        color={'success'}
      >
        {t('approve')}
      </Button>
      <Button
        size={'small'}
        onClick={() => onRequestChange(absenceId)}
        startIcon={<ChangeCircle fontSize="small" color={'info'} />}
        color={'info'}
      >
        {t('label_change')}
      </Button>
      <Button
        size={'small'}
        onClick={() => onReject(absenceId)}
        startIcon={<Cancel fontSize="small" color={'error'} />}
        color={'error'}
      >
        {t('reject')}
      </Button>
    </Box>
  );
};
